function Waypoints() {
	var self = this;
	this.init();
}

Waypoints.prototype.init = function() {
	var self = this;
	self.bound = {scale: 1};

	this.addWaypoints();
	this.showAnimations();
	this.updateOnResize();

	$(window).on('load', function() {
		self.addClassOnLoad();
	});
};

Waypoints.prototype.addWaypoints = function() {
	var self = this;
};

Waypoints.prototype.addClassOnLoad = function() {
	var self = this;
};

Waypoints.prototype.hideItemsOnPageLoad = function() {
	var self = this;
};

Waypoints.prototype.showAnimations = function() {
	var self = this;

	$('section.section--imagebox-2.section--rounded .img-container').each(function() {
		const img = $(this);
		const svgEl = $(this).find('svg path');
		let bound = {scale: 1};
		
		img.addClass('-visible');

		gsap.timeline({
			scrollTrigger: {
				trigger: img,
				start: "top top",
				end: "bottom top",
				scrub: true,
			}
		}).to(bound, {
			scale: (app.mq<4)?0.9:0.85,
			onUpdate: () => {
				svgEl.attr('d', 'M 0 '+(img.innerHeight()*bound.scale)+' C '+(img.innerWidth()*0.4)+' '+img.innerHeight()+' '+(img.innerWidth()*0.6)+' '+img.innerHeight()+' '+img.innerWidth()+' '+(img.innerHeight()*bound.scale)+' L '+img.innerWidth()+' 0 L 0 0 L 0 '+(img.innerHeight()*bound.scale)+' Z');
			}
		});
	});

	$('section.section--rounded + section:has(.section-mask)').each(function() {
		const trigger = $(this).find('svg.section-mask');
		const svgEl = $(this).find('svg.section-mask path');
		let bound = {scale: 1};
		
		gsap.timeline({
			scrollTrigger: {
				trigger: trigger,
				start: "bottom 90%",
				end: "bottom center",
				scrub: true,
			}
		}).to(bound, {
			scale: (app.mq<4)?0.9:0,
			onUpdate: () => {
				// console.log($(this), trigger.innerHeight(), trigger.innerWidth());
				svgEl.attr('d', 'M 0 '+(trigger.innerHeight()*bound.scale)+' C '+(trigger.innerWidth()*0.4)+' '+trigger.innerHeight()+' '+(trigger.innerWidth()*0.6)+' '+trigger.innerHeight()+' '+trigger.innerWidth()+' '+(trigger.innerHeight()*bound.scale)+' L '+trigger.innerWidth()+' 0 L 0 0 L 0 '+(trigger.innerHeight()*bound.scale)+' Z');
			}
		});
	});

	$('body.-tourist section.section--imagebox-1, section.section--imagebox-2').each(function() {
		const img = $(this).find('.img-container img');
		
		gsap.timeline({
			scrollTrigger: {
				trigger: img,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
			}
		}).from(img, {
			y: '10%',
			scale: 1.2,
		}).to(img, {
			y: '0%',
			scale: 1,
		});
	});

	$('img[src*="kropla-zielona.svg"], img[src="/files//ikony/kropla.svg"], img[src="/files/ikony/kropla.svg"], img[src="/files//ikony/kropla-jasnozielona.svg"]').each(function() {
		const img = $(this);
		const section = img.closest('section');
		section.css('z-index', 10);
		
		gsap.timeline({
			scrollTrigger: {
				trigger: section,
				start: "top top",
				end: "bottom top",
				scrub: true,
			}
		}).to(img, {
			y: '15vh',
			ease: 'power2.out',
		}).to(img, {
			opacity: 0,
			ease: 'power2.in',
		}, '<');
	});

	$('section.section--imagebox-3').each(function() {
		const img = $(this).find('.img-container img');
		
		gsap.timeline({
			scrollTrigger: {
				trigger: img,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
			}
		}).from(img, {
			y: '25%',
		});
	});

	$('section.section--banners-1').each(function() {
		const trigger = $(this);
		
		gsap.timeline({
			scrollTrigger: {
				trigger: trigger,
				start: "top bottom",
				end: "center center",
				scrub: true,
				ease: 'power2.out'
			}
		}).from(trigger.find('.section--banners-item:first-child'), {
			x: '-25%',
			opacity: 0,
		}).from(trigger.find('.section--banners-item:last-child'), {
			x: '25%',
			opacity: 0,
		}, '=');
	});

	$('section.section--centered').each(function() {
		const trigger = $(this);
		
		gsap.timeline({
			scrollTrigger: {
				trigger: trigger,
				start: "top bottom",
				end: "center center",
				scrub: true,
			}
		}).from(trigger.find('.bg'), {
			x: '-25%',
			opacity: 0,
		});
	});

	$('section.section--cstudies-index').each(function() {
		const trigger = $(this).find('.cstudies-index-item');
		
		gsap.timeline({
			scrollTrigger: {
				trigger: trigger,
				start: "top bottom",
				end: "bottom 75%",
				scrub: false,
			}
		}).from(trigger, {
			x: '50%',
			opacity: 0,
			stagger: 0.1,
			ease: 'power2.out',
		});
	});

	$('section.section--places-index, section.section--walks-index').each(function() {
		const trigger = $(this).find('.square-index-item');
		
		gsap.timeline({
			scrollTrigger: {
				trigger: trigger,
				start: "top bottom",
				end: "center bottom",
				// scrub: true,
			}
		}).from(trigger, {
			x: '50%',
			opacity: 0,
			stagger: 0.1,
			ease: 'power2.out',
		});
	});

	$('.gallery-container').each(function() {
		const trigger = $(this).find('.gallery-item');
		
		gsap.timeline({
			scrollTrigger: {
				trigger: trigger,
				start: "top bottom",
				end: "center bottom",
				// scrub: true,
			}
		}).from(trigger, {
			x: '50%',
			opacity: 0,
			stagger: 0.1,
			ease: 'power2.out',
		});
	});
};

Waypoints.prototype.updateOnResize = function() {
	var self = this;
	$('section.section--imagebox-2.section--rounded .img-container').each(function() {
		const img = $(this);
		const svgEl = $(this).find('svg path');
		let bound = {scale: 1};
		svgEl.attr('d', 'M 0 '+(img.innerHeight()*bound.scale)+' C '+(img.innerWidth()*0.4)+' '+img.innerHeight()+' '+(img.innerWidth()*0.6)+' '+img.innerHeight()+' '+img.innerWidth()+' '+(img.innerHeight()*bound.scale)+' L '+img.innerWidth()+' 0 L 0 0 L 0 '+(img.innerHeight()*bound.scale)+' Z');
	});
	$('section.section--rounded + section:has(.section-mask)').each(function() {
		const img = $(this).find('svg.section-mask');
		const svgEl = $(this).find('svg.section-mask path');
		let bound = {scale: 1};
		svgEl.attr('d', 'M 0 '+(img.innerHeight()*bound.scale)+' C '+(img.innerWidth()*0.4)+' '+img.innerHeight()+' '+(img.innerWidth()*0.6)+' '+img.innerHeight()+' '+img.innerWidth()+' '+(img.innerHeight()*bound.scale)+' L '+img.innerWidth()+' 0 L 0 0 L 0 '+(img.innerHeight()*bound.scale)+' Z');
	});
};
